var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartInstantly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 107",
    style: {
      enableBackground: "new 0 0 104 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#647A8A;}\r\n\t.st1{fill:#DC8743;}\r\n\t.st2{fill:#ECF0F3;}\r\n\t.st3{fill:#E66454;}\r\n\t.st4{fill:#2BA2DC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M22.6,106.5l-2-1.7c0,0,0.5-0.6,1.5-1.5l1.9,1.9C23.1,105.9,22.7,106.5,22.6,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st0",
    d: "M27,102.4l-1.7-2.1c1.1-0.9,2.2-1.8,3.4-2.6l1.6,2.2C29.1,100.7,28,101.5,27,102.4z  M33.7,97.6l-1.4-2.3c1.2-0.7,2.5-1.5,3.7-2.1l1.2,2.4C36.1,96.2,34.9,96.9,33.7,97.6z M41,93.8l-1.1-2.5c1.3-0.6,2.6-1.1,4-1.6 l0.9,2.5C43.5,92.7,42.2,93.2,41,93.8z M85.3,91c-1.3-0.4-2.7-0.7-4-1l0.6-2.6c1.4,0.3,2.8,0.6,4.2,1L85.3,91z M48.7,91l-0.8-2.6 c1.4-0.4,2.8-0.8,4.2-1.1l0.6,2.6C51.3,90.3,50,90.6,48.7,91z M77.2,89.3c-1.4-0.2-2.7-0.4-4.1-0.5l0.3-2.7 c1.4,0.1,2.8,0.3,4.2,0.5L77.2,89.3z M56.7,89.2l-0.4-2.7c1.4-0.2,2.8-0.4,4.3-0.5l0.2,2.7C59.4,88.8,58.1,89,56.7,89.2z M69,88.5 c-1.4-0.1-2.8-0.1-4.1,0l-0.1-2.7c1.4,0,2.8,0,4.3,0L69,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M92.4,93.2l-1.3-0.4c-0.6-0.2-1.3-0.4-1.9-0.6l0.8-2.6c0.2,0.1,0.4,0.1,0.6,0.2 c0.1-0.2,0.1-0.4,0.2-0.6l2.6,0.7c-0.3,1.3-0.6,2-0.6,2L92.4,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M94.4,86.2l-2.6-0.5c0.2-1.2,0.4-2.4,0.5-3.6l2.7,0.3C94.8,83.6,94.6,84.9,94.4,86.2z  M95.2,78.5l-2.7,0l0-0.7c0-1,0-2-0.1-2.9l2.7-0.2c0.1,1,0.1,2.1,0.1,3.2L95.2,78.5z M91.9,71.3c-0.3-1.2-0.6-2.3-1.1-3.4l2.5-1 c0.5,1.2,0.9,2.5,1.2,3.8L91.9,71.3z M89.1,64.9c-0.6-1-1.4-1.9-2.2-2.7l1.9-1.9c1,0.9,1.8,2,2.6,3.1L89.1,64.9z M84.2,60 c-1-0.6-2-1.2-3.1-1.6l1-2.5c1.3,0.5,2.5,1.1,3.5,1.8L84.2,60z M77.7,57.3c-1.1-0.3-2.3-0.5-3.5-0.7l0.4-2.7 c1.3,0.2,2.6,0.4,3.8,0.7L77.7,57.3z M70.5,56.3c-1.2-0.1-2.4-0.1-3.7,0l-0.1-2.7c1.3,0,2.6,0,3.9,0L70.5,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M61.1,56.6L60.9,54c0.7-0.1,1.4-0.1,2-0.2l0.2,2.7C62.5,56.5,61.8,56.6,61.1,56.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st1",
    d: "M62.6,55.5c1.2-4.2,2.5-7.3,3.6-9.4c0.7-1.4,2.2-3.6,3.4-4.7c2.3-2.3,3.6-5.6,3.1-9.2 c-0.6-4.9-4.7-8.8-9.6-9.4c-6.6-0.7-12.2,4.4-12.2,10.9c0,3,1.2,5.8,3.2,7.7c1.2,1.2,2.7,3.4,3.4,4.8c1.1,2.1,2.4,5.1,3.6,9.3 C61.5,56.1,62.4,56.1,62.6,55.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st2",
    cx: 62,
    cy: 33.6,
    r: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st3",
    d: "M23,104.2c2.4-8.2,5-14,7.1-17.7c1.5-2.8,3.6-5.3,5.8-7.6c3.5-3.6,5.6-8.6,5.5-14.1 c-0.3-10.2-8.6-18.7-18.7-19.1C11.3,45.1,2,54.1,2,65.3c0,5.3,2.1,10,5.4,13.5c2.2,2.3,4.3,4.8,5.8,7.7c2.1,3.8,4.7,9.5,7.1,17.7 C20.8,105.5,22.6,105.5,23,104.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4_",
    className: "st2",
    cx: 21.7,
    cy: 65.4,
    r: 13.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st4",
    d: "M93.1,91.3c1.2-4.2,2.5-7.3,3.6-9.4c0.7-1.4,2.2-3.6,3.4-4.7c2.3-2.3,3.6-5.6,3.1-9.2 c-0.6-4.9-4.7-8.8-9.6-9.4c-6.6-0.7-12.2,4.4-12.2,10.9c0,3,1.2,5.8,3.2,7.7c1.2,1.2,2.7,3.4,3.4,4.8c1.1,2.1,2.4,5.1,3.6,9.3 C91.9,91.9,92.9,91.9,93.1,91.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    className: "st2",
    cx: 92.4,
    cy: 69.4,
    r: 7.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartInstantly);
export default __webpack_public_path__ + "static/media/start-instantly.99b74c67558d120e08bf9d1a29e16a60.svg";
export { ForwardRef as ReactComponent };